import { render, staticRenderFns } from "./OrderDetailTab.vue?vue&type=template&id=1694ec10&scoped=true"
import script from "./OrderDetailTab.vue?vue&type=script&lang=js"
export * from "./OrderDetailTab.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailTab.vue?vue&type=style&index=0&id=1694ec10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1694ec10",
  null
  
)

export default component.exports